import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { LegacyApiEvents } from '@deezer/legacy-api';
import EventTarget from '@deezer/event-target';
import LegacyUserEvent, { LegacyUserEvents } from "./events.js";
import User from "./user.js";
import { transformLegacyChild, transformLegacyUser } from "./utils.js";
export default class LegacyUser extends EventTarget {
  constructor(legacyApi, pictureDomain, appName) {
    super();
    this._user = void 0;
    this._api = void 0;
    this._legacyUser = void 0;
    this._pictureDomain = void 0;
    this._pendingGetUserDataHanlded = false;
    this.missingInfos = void 0;
    this.error = void 0;
    this._appName = void 0;
    this._api = legacyApi;
    this._pictureDomain = pictureDomain;
    this._appName = appName;
    this._api.addEventListener(LegacyApiEvents.CALL_SUCCESS, event => {
      if (event.detail.method === 'deezer.getUserData') {
        if (!this._pendingGetUserDataHanlded) {
          this.initializeFromLegacyUser(event.detail.data);
        }
        this._pendingGetUserDataHanlded = false;
      }
    });
  }
  initialize() {
    var _this = this;
    return _asyncToGenerator(function* () {
      _this._pendingGetUserDataHanlded = true;
      try {
        const initializationResult = yield _this._api.call(_extends({
          method: 'deezer.getUserData'
        }, _this._appName && {
          data: {
            APP_NAME: _this._appName
          }
        }));
        _this.initializeFromLegacyUser(initializationResult);
      } catch (err) {
        var _err$payload;
        _this.missingInfos = err == null || (_err$payload = err.payload) == null ? void 0 : _err$payload.required_info;
        _this.error = err;
        _this.dispatchEvent(new LegacyUserEvent(LegacyUserEvents.USER_ERROR));
      }
    })();
  }
  initializeFromLegacyUser(legacyUserData) {
    this._legacyUser = legacyUserData;
    this._user = new User(transformLegacyUser(this._legacyUser), this._pictureDomain);
    this.error = undefined;
    this.dispatchEvent(new LegacyUserEvent(LegacyUserEvents.USER_CHANGED));
  }
  fetchChildren() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      if (!_this2._user) {
        throw Error('user not initialized, call `initialize()` first');
      }
      if (_this2._user.id === '0' || !_this2._user.familyStatus || !_this2._user.familyStatus.childCount) {
        return [];
      }
      const children = yield _this2._api.call({
        method: 'deezer.getChildAccounts'
      });
      if (children.length === 0) {
        return [];
      }
      return children.map(child => transformLegacyChild(child, _this2._pictureDomain));
    })();
  }
  switchFamilyProfile(userId) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      if (!_this3._user) {
        throw Error('user not initialized, call `initialize()` first');
      }
      if (!_this3._user.familyStatus.isActive) {
        return;
      }
      if (_this3._user.id === userId) {
        return;
      }
      yield _this3._api.call({
        method: 'user.loginMulti',
        data: {
          account_id: userId
        }
      });
      yield _this3.initialize();
    })();
  }
  get user() {
    var _this$_user;
    if (!this._user && !this.missingInfos) {
      throw Error('user not initialized, call `initialize()` first');
    }
    return (_this$_user = this._user) != null ? _this$_user : null;
  }

  /**
   * @deprecated This getter should not be used and useful properties should be ported to the parsed user.
   */
  get legacyUser() {
    var _this$_legacyUser;
    if (!this._legacyUser && !this.missingInfos) {
      throw Error('user not initialized, call `initialize()` first');
    }
    return (_this$_legacyUser = this._legacyUser) != null ? _this$_legacyUser : null;
  }
}